import { useQuery } from '@tanstack/react-query'

import { CAR_STORY_QUERY_KEYS } from '../../lib'
import { type IGetMycleContentsBySeriesParams } from '../../model'
import { getMycleContentsBySeries } from '../request'

const useMycleContentsBySeriesQuery = ({
  code,
  page = 0,
  size = 20,
}: IGetMycleContentsBySeriesParams) =>
  useQuery({
    queryKey: CAR_STORY_QUERY_KEYS.SERIES.list(code, page, size),
    queryFn: () => getMycleContentsBySeries({ code, page, size }),
    throwOnError: false,
  })

export default useMycleContentsBySeriesQuery
